import fetchRequests from "Api/Fetch";
import Utils from "Utils";
const Api = {
  getStartupDocuments: (startupId) => {
    return fetchRequests.get(`/startups/documents/?startupID=${startupId}`);
  },

  uploadStartupDocuments: (data) => {
    const payload = Utils.objectToForm(data);
    return fetchRequests.securedFormApi(
      "/startups/documents/",
      "POST",
      payload
    );
  },
};
export default Api;
